import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ClientInfo from '@pages/partners-order/client-info/ClientInfo';
import ClientAddress from '@pages/partners-order/client-address/ClientAddress';
import ContactInfo from '@pages/partners-order/contact-info/ContactInfo';
import SizesUnits from '@pages/partners-order/sizes-units/SizesUnits';
import PaymentShipping from '@pages/partners-order/payment-shipping/PaymentShipping';
import Message from '@pages/partners-order/message/Message';
import Footer from '@pages/partners-order/footer/Footer';


const PartnersOrder = () => {
	const { t } = useTranslation('forms');

	const formRef = useRef<HTMLDivElement>(null);

	const scrollToTop = useCallback(() => {
		formRef?.current?.scrollIntoView({ behavior: 'smooth' });
	},[ formRef ]);


	return (
		<div className='app-page partners-order-page' ref={formRef}>
			
			<h1>{t('partnersOrder.header')}</h1>

			<div className='intro-text'>
				<p>{t('partnersOrder.introText1')}</p>
				<p>{t('partnersOrder.introText2')}</p>
			</div>

			<ClientInfo />

			<ClientAddress />

			<ContactInfo />

			<SizesUnits />

			<PaymentShipping />

			<Message />

			<Footer scrollToTop={scrollToTop} />

		</div>
	);
};

export default PartnersOrder;